// extracted by mini-css-extract-plugin
export default {"wrapper":"Portal_wrapper__4jh4R","content":"Portal_content__kxoJF"};